import React from 'react'
import PropTypes from 'prop-types'

const Grid = (props) => {
  const {
    children,
  } = props

  const cells = React.Children.toArray(children) || []

  return (
    <div className="row-v2__grid-wrapper">
      <ul className="row-v2__items-list">
        {cells.map((cell, i) => (
          <li
            className="row-v2__item row-v2__item--visible row-v2__item--disable-scale"
            key={i}
          >
            <div className="row-v2__item-inner row-v2__item-inner--no-shadow">
              {cell}
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}

Grid.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Grid
